import React, { useContext, useState, useEffect, useRef } from 'react';
import Button from '@material-ui/core/Button';
import { InProgress, Submitted } from '@mummssoftware/utils/constants';
import { isAgencyEnabled } from '@mummssoftware/utils/utils';
import { Context } from '../../context';
import { CPPContext } from '../Context/CPPContext';
import {
  SUBMIT_PLAN,
  SET_SUBMIT_PLAN_ACTIVE,
  DISCARD_EDIT,
  SET_CPP,
  Rendering,
  Editing,
} from '../Context/constants';
import { SubmitPlanDiv } from '../../components/layout/WrapperDiv';
import defaults from '../../translations/en.json';

export const SubmitPlan = React.memo(() => {
  const {
    currentUser,
    smallWidget,
    planCache,
    deleteCarePlanProblem,
  } = useContext(Context);
  const {
    dispatch,
    cppForm,
    submitPlanActive,
    resetDiscardEdit,
    submitPlan,
  } = useContext(CPPContext);
  const [isSubmitDisabled, setIsDisabled] = useState<boolean>(true);
  const [isDiscardDisabled, setDiscardDisabled] = useState<boolean>(false);
  const [saveInProgress, setSaveInProgress] = useState(false);
  const isSubmittingRef = useRef(false);

  useEffect(() => {
    if (!saveInProgress) {
      isSubmittingRef.current = false;
    }
  }, [saveInProgress]);

  const showSubmit = !smallWidget && cppForm;
  const isRendering = cppForm && cppForm.type === Rendering;
  const isEditing = cppForm && cppForm.type === Editing;
  const submittedPlan = cppForm && cppForm.status === Submitted;

  useEffect(() => {
    // if change has been registered then submit button active
    if (submitPlanActive) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [submitPlanActive]);

  useEffect(() => {
    if (!submitPlan) {
      setSaveInProgress(false);
    }
  }, [submitPlan]);

  // reactivate discard button
  useEffect(() => {
    if (resetDiscardEdit) {
      setDiscardDisabled(false);
    }
  }, [resetDiscardEdit]);

  const onSubmitPlan = (payload: { status: mumms.SubmitStatus }) => {
    if (isSubmittingRef.current) {
      return;
    }
    isSubmittingRef.current = true;
    setSaveInProgress(true);
    setIsDisabled(true);
    // Preview Form is showing
    if (isEditing && payload.status === Submitted) {
      setDiscardDisabled(true);
    }
    dispatch({
      type: SUBMIT_PLAN,
      payload,
    });
  };

  const onDiscardPlan = async () => {
    if (saveInProgress) {
      return;
    }
    setIsDisabled(true);
    dispatch({
      type: DISCARD_EDIT,
      payload: true,
    });
    dispatch({
      type: SET_SUBMIT_PLAN_ACTIVE,
      payload: false,
    });
    // if Rendering
    if (isRendering) {
      // delete endpoint
      planCache && (await deleteCarePlanProblem(planCache));
      dispatch({
        type: SET_CPP,
        payload: null,
      });
    }
    // If Editing diff action in FormRenderer and ExpandedCPP
  };

  // show watermark based on agencies
  const enabledCPPBins: string = window.env?.enabledCPPBins as string;
  const isSelectedAgency = isAgencyEnabled(enabledCPPBins, currentUser);

  return showSubmit ? (
    <SubmitPlanDiv>
      <Button
        type="submit"
        variant="contained"
        size="small"
        disabled={isDiscardDisabled || saveInProgress}
        onClick={onDiscardPlan}
        color="primary"
      >
        {defaults.discard}
      </Button>
      {!submittedPlan && (
        <Button
          type="submit"
          variant="contained"
          size="small"
          disabled={isSubmitDisabled || saveInProgress}
          onClick={() => onSubmitPlan({ status: InProgress })}
          color="primary"
        >
          {defaults.saveWIP}
        </Button>
      )}
      {!isSelectedAgency && (
        <Button
          type="submit"
          variant="contained"
          size="small"
          disabled={isSubmitDisabled || saveInProgress}
          onClick={() => onSubmitPlan({ status: Submitted })}
          color="primary"
        >
          {defaults.submit}
        </Button>
      )}
    </SubmitPlanDiv>
  ) : (
    <></>
  );
});
